import { EnvironmentTypes, HeaderSettings, IHeaderSettings } from "./Settings"

const environment: string = process.env?.REACT_APP_ENVIRONEMENT ?? "local";

function GetEnvironment(): EnvironmentTypes {
    switch (environment.toLowerCase()) {
        case "local": {
            return EnvironmentTypes.local;
        }
        case "dev": {
            return EnvironmentTypes.dev;
        }
        case "qa": {
            return EnvironmentTypes.qa;
        }
        case "sandbox": {
            return EnvironmentTypes.sandbox;
        }
        case "staging": {
            return EnvironmentTypes.staging;
        }
        case "prod": {
            return EnvironmentTypes.prod;
        }
    }

    return EnvironmentTypes.local;
}

function GetEnvironmentName(environment: EnvironmentTypes): string {
    switch (environment) {
        case EnvironmentTypes.local: {
            return "Local Development";
        }
        case EnvironmentTypes.dev: {
            return "Development";
        }
        case EnvironmentTypes.qa: {
            return "Quality Assurance";
        }
        case EnvironmentTypes.sandbox: {
            return "Sandbox";
        }
        case EnvironmentTypes.staging: {
            return "Staging";
        }
        case EnvironmentTypes.prod: {
            return "Production";
        }
    }
}

function DisplayEnvironmentBar(environment: EnvironmentTypes): boolean {
    switch (environment) {
        case EnvironmentTypes.local: {
            return true;
        }
        case EnvironmentTypes.dev: {
            return true;
        }
        case EnvironmentTypes.qa: {
            return true;
        }
        case EnvironmentTypes.sandbox: {
            return true;
        }
        case EnvironmentTypes.staging: {
            return true;
        }
        case EnvironmentTypes.prod: {
            return false;
        }
    }
}

function GetHeaderHeight(environment: EnvironmentTypes): string {
    let isEnvironmentBarDisplayed: boolean = DisplayEnvironmentBar(environment);
    let headerSettings: IHeaderSettings = HeaderSettings();

    let headerHeight = headerSettings.navBarHeight;

    if (isEnvironmentBarDisplayed) {
        headerHeight = headerHeight + headerSettings.environmentBarHeight;
    }

    return headerHeight.toString()+headerSettings.units;
}

function GetDataGridHeight(environment: EnvironmentTypes): string {
    let isEnvironmentBarDisplayed: boolean = DisplayEnvironmentBar(environment);
    let headerSettings: IHeaderSettings = HeaderSettings();

    let headerHeight = headerSettings.navBarHeight;

    if (isEnvironmentBarDisplayed) {
        headerHeight = headerHeight + headerSettings.environmentBarHeight;
    }

    return (headerHeight * 3).toString()+headerSettings.units;
}

export interface IEnvironmentSettings {
    environment: EnvironmentTypes;
    environmentName: string;
    displayEnvironmentBar: boolean;
    headerHeight: string;
    dataGridHeigt: string;
};

function EnvironmentSettings(): IEnvironmentSettings {
    const environment = GetEnvironment();
    const environmentName = GetEnvironmentName(environment);
    const displayEnvironmentBar = DisplayEnvironmentBar(environment);
    const headerHeight = GetHeaderHeight(environment);
    const dataGridHeight = GetDataGridHeight(environment);

    const environmentSettings: IEnvironmentSettings = {
        environment: environment,
        environmentName: environmentName,
        displayEnvironmentBar: displayEnvironmentBar,
        headerHeight: headerHeight,
        dataGridHeigt: dataGridHeight,
    };

    return environmentSettings;
}

export { EnvironmentSettings };